module.exports = __webpack_public_path__ + "img/credit-qr-1.cc701ee8.png";